export default {
    hero: {
        title: "Transforming Malaysian Agriculture with Grafted Crop Technology",
        subtitle:
            "Higher yield, lower risk, and scalable agriculture projects powered by Agrifutura’s technology.",
        video: "/videos/hero.mp4",
        image: "/images/hero-bg.png",
    },

    about: {
        title: "Company Overview",
        text: [
            "At Agrifutura Sdn Bhd, we strongly believe that the future of Malaysia lies in agriculture. Our mission is to make agriculture profitable, sustainable, and attractive to the next generation. By empowering youth to embrace agribusiness, we aim to reduce the country’s import dependency, create employment opportunities, and boost national revenue.",
            "We are proud pioneers in brinjal farming using advanced grafting technology, a breakthrough that allows us to overcome common crop diseases and achieve continuous, high-yield harvests. This innovation positions us at the forefront of modern, resilient farming practices in Malaysia.",
        ],
        video: "/videos/about.mp4",
        image: "/images/about-bg.png",
    },

    mission: {
        vision: {
            title: "Our Vision",
            text: "We harness precision grafting technology to create hybrid plants with superior traits, such as increased yield, disease resistance, and adaptability to environmental stressors.",
        },
        mission: {
            title: "Our Mission",
            text: "By integrating proprietary methods for natural pesticide resistance, we help farmers grow healthier crops with fewer chemical inputs, lowering costs and protecting ecosystems.",
        },
        video: "/videos/mission.mp4",
        image: "/images/mission-bg.png",
    },

    team: {
        title: "Our Team",
        members: [
            {
                name: "KAI JUN",
                role: "Founder / CEO",
                image: "/images/team1.jpg",
            },
            { name: "RAYMOND TAN", role: "CMO", image: "/images/team2.jpg" },
            {
                name: "Clarance Tew",
                role: "CTO",
                image: "/images/team3.jpg",
            },
        ],
        video: "/videos/team.mp4",
        image: "/images/team-bg.png",
    },

    projects: {
        title: "Our Projects",
        items: [
            {
                title: "AGFT (A)",
                size: "4 acres",
                yearStarted: "Feb 2025",
                image: "/images/brinjal.jpeg",
            },
            {
                title: "CRCF",
                size: "4.5 acres",
                yearStarted: "March 2025",
                image: "/images/greenhouse.jpg",
            },
            {
                title: "AGFT (B)",
                size: "2.5 acres",
                yearStarted: "May 2025",
                image: "/images/harvest.jpeg",
            },
            {
                title: "AGFT (C)",
                size: "6 acres",
                yearStarted: "December 2025",
                image: "/images/garden.png.jpeg",
            },
            {
                title: "AGFT (D)",
                size: "4.7 acres",
                yearStarted: "Upcoming",
                image: "/images/result.jpeg",
            },
        ],
        video: "/videos/portfolio.mp4",
        image: "/images/portfolio-bg.png",
    },

    investment: {
        title: "Investment Opportunities",
        text: "Agrifutura offers unique opportunities for investors to participate in the transformation of Malaysia's agricultural landscape. By supporting our innovative grafting technologies and sustainable practices, you invest in both profitable returns and a healthier planet.",
        video: "/videos/investment.mp4",
        image: "/images/investment-bg.jpg",
    },

    portfolio: {
        title: "Our Portfolio",
        items: [
            {
                title: "Grafted Brinjal Farming",
                description: "Disease-resistant brinjal with continuous yield.",
                image: "/images/brinjal.jpeg",
            },
            {
                title: "Sustainable Greenhouses",
                description:
                    "Energy-efficient structures for high-value crops.",
                image: "/images/greenhouse.jpg",
            },
            {
                title: "Results",
                description: "",
                image: "/images/result.jpeg",
            },
            {
                title: "Production Process",
                description: "",
                image: "/images/production_process.jpg",
            },
            {
                title: "Sales Services",
                description: "",
                image: "/images/sales_services.jpg",
            },
            {
                title: "BSF30",
                description: "",
                image: "/images/bsf30.jpg",
            },
            {
                title: "BSF50",
                description: "",
                image: "/images/bsf50.jpg",
            },
            {
                title: "BSF77",
                description: "",
                image: "/images/bsf77.jpg",
            },
            {
                title: "BSF88",
                description: "",
                image: "/images/bsf88.jpg",
            },
            {
                title: "BSF99",
                description: "",
                image: "/images/bsf99.jpg",
            },
            {
                title: "BSF108",
                description: "",
                image: "/images/bsf108.jpg",
            },
        ],
        video: "/videos/portfolio.mp4",
        image: "/images/portfolio-bg.png",
    },
    testimonials: {
        title: "Our Testimonials",
        video: "/videos/testimonials.mp4",
        image: "/images/testimonials-bg.jpg",
    },

    contact: {
        title: "Get In Touch",
        subtitle:
            "We'd love to hear from you. Reach out via form or use the info below.",
        info: {
            location:
                "14a, Jalan Flora Utama 3, Taman Flora Utama, 83000 Batu Pahat, Johor, Malaysia",
            email: "agrifuturagroup@gmail.com",
            phone: "+60 12-780 2773/+60 17-785 3060",
        },
        video: "/videos/contact.mp4",
        image: "/images/contact-bg.jpg",
    },
};
